export const ROLE_ALERT = 'alert';
export const HIDDEN_TRUE = 'true';
export const TAB_INDEX_VALUE = -1;
export const TEXT_AS_P = 'p';
